import Layout from '../../components/feature/Layout';
import KPICards from './components/KPICards';
import { DailyVisitorsChart, HourlyTrafficChart } from './components/ChartsRow1';
import { CampaignPieChart, SourceConversionChart, DeviceChart } from './components/ChartsRow2';
import { TopCampaignsWidget, TopButtonsWidget, RecentLeadsWidget, RecentEventsWidget, TopSourcesWidget } from './components/Widgets';

export default function Dashboard() {
  return (
    <Layout>
      <div className="space-y-6">
        <KPICards />
        <div className="grid grid-cols-1 xl:grid-cols-5 gap-5">
          <div className="xl:col-span-3"><DailyVisitorsChart /></div>
          <div className="xl:col-span-2"><HourlyTrafficChart /></div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <CampaignPieChart />
          <SourceConversionChart />
          <DeviceChart />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-5">
          <TopCampaignsWidget />
          <TopButtonsWidget />
          <RecentLeadsWidget />
          <RecentEventsWidget />
          <TopSourcesWidget />
        </div>
      </div>
    </Layout>
  );
}
